import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { dispatch } from '../../dispatcher/Dispatcher';

import { getItem as getLang } from '../../common/lang';

import Header from '../../components/Header/Header.jsx';
import PullLoader from '../../components/PullLoader/PullLoader.jsx';
import RecordList from '../../components/RecordList/RecordList.jsx';
import FormControl from '../../components/FormControl/FormControl.jsx';
import TextInput from '../../components/TextInput/TextInput.jsx';
import Button from '../../components/Button/Button.jsx';
import Form from '../../components/Form/Form.jsx';
import Loader from '../../components/Loader/Loader.jsx';
import PageOpener from '../../components/PageOpener/PageOpener.jsx';

import RepairClockInStore from '../../stores/RepairClockInStore';
import RepairClockInDataUtils from '../../data-utils/RepairClockInDataUtils';

class RepairClockInMgrPending extends Component {

	static getStores() {
		return [RepairClockInStore];
	}

	static calculateState() {
		return RepairClockInStore.getState();
	}

	constructor(props) {
		super(props);
		RepairClockInDataUtils.mssRciPendingRecords({
			page: 1
		});
	}

    render(){
		const{
			submitting = false,
			selectTable,
			refreshList,
			pendingRecords = [],
			status = 'loading'
		} = this.state;
        return (
            <div>
                <Header
					back
					title={getLang('PENDING')}
				/>
				<PullLoader ref="pullLoader" status={status} onLoad={::this.loadMore}>
					<ul className={'record-list' + (selectTable ? ' record-list-selectable' : '')}>
					{
						pendingRecords.map((record, index) => {
							return (
								<li>
									<a className='record-item' href={`#/rci-record-mgr/`+record.app_001_id}>
										<span className='record-item-name'>{record.empName} - {record.app_001_c001v}</span>
										<span className='record-item-time'>{record.app_001_sdate} - {record.app_001_edate}</span>
										<span className={'record-item-status'}>{record.app_statev}</span>
									</a>
								</li>
							);
						})}
					</ul>
				</PullLoader>
				{/*<Button icon='plus' action onClick={::this.openApply} />

				<PageOpener ref='apply'>
					<Loader status={'loaded'}>
						<div className='login-forgot-page'>
								<FormControl label={'理由'} tips={getLang('REQUIRED')}>
									<TextInput ref='tbReason' id='tbReason' name='tbReason'
											type='text' required />
								</FormControl>
								<FormControl label={'开始时间'} tips={getLang('REQUIRED')}>
									<TextInput ref='tbStartTime' id='tbStartTime' name='tbStartTime'
											type='datetime' required />
								</FormControl>
								<FormControl label={'结束时间'} tips={getLang('REQUIRED')}>
									<TextInput ref='tbEndTime' id='tbEndTime' name='tbEndTime'
											type='datetime' required />
								</FormControl>
						</div>
						<div className="row">
							<div className="col-1-2">
								<Button type='button'
												disabled={submitting}
												text={getLang('SAVE')}/>
							</div>
							<div className="col-1-2">
								<Button type='button'
												disabled={submitting}
												text={getLang('SUBMIT')}/>
							</div>
						</div>
					</Loader>
				</PageOpener>*/}
            </div>
        );
    }

	/**
	 * 加载更多
	 */
	loadMore() {
		//alert(1);
		const currentQuery = this.state.pendingQuery;

		RepairClockInDataUtils.mssRciPendingRecords({
			...currentQuery,
			page: currentQuery.page + 1
		});
	}

}

export default Container.create(RepairClockInMgrPending);



// WEBPACK FOOTER //
// ./src/containers/RepairClockIn/RepairClockInMgrPendingContainer.js